import createTrackingEventName from "app/pages/sales-intelligence/utils/testing/createTrackingEventName";
import type { track as TrackFunction } from "pro-features/components/WithTrack/src/WithTrack";

const SI_EMPLOYEE_PROFILES_CATEGORY = "SI employee profiles";

const createEmployeeProfilesTrackingService = (track: TrackFunction) => {
    const trackEmployeeProfilesEvent = (action: string, eventName: string): void => {
        track(SI_EMPLOYEE_PROFILES_CATEGORY, action, eventName);
    };

    return {
        trackNewEmployeeProfile() {
            trackEmployeeProfilesEvent("click", "new employee profile");
        },
        trackVisibilityChange(isShared: boolean) {
            trackEmployeeProfilesEvent(
                "click",
                createTrackingEventName("visibility", isShared ? "shared" : "private"),
            );
        },
        trackSegmentChange(segment: string) {
            trackEmployeeProfilesEvent("click", createTrackingEventName("segment", segment));
        },
        trackListRetry() {
            trackEmployeeProfilesEvent("click", createTrackingEventName("retry", "list"));
        },
        trackEditEmployeeProfile(isShared: boolean) {
            trackEmployeeProfilesEvent(
                "click",
                createTrackingEventName("edit employee profile", isShared ? "shared" : "private"),
            );
        },
        trackDeleteOpen() {
            trackEmployeeProfilesEvent("click", createTrackingEventName("delete employee profile", "open"));
        },
        trackDeleteConfirm() {
            trackEmployeeProfilesEvent("click", createTrackingEventName("delete employee profile", "confirm"));
        },
        trackDeleteCancel() {
            trackEmployeeProfilesEvent("click", createTrackingEventName("delete employee profile", "cancel"));
        },
        trackBulkDelete(count: number) {
            trackEmployeeProfilesEvent("click", createTrackingEventName("delete selected", count));
        },
        trackProfileSubmit(mode: "create" | "edit") {
            trackEmployeeProfilesEvent("click", createTrackingEventName("profile submit", mode));
        },
        trackProfileDeleteFromModalOpen() {
            trackEmployeeProfilesEvent("click", createTrackingEventName("profile delete from modal", "open"));
        },
    };
};

export default createEmployeeProfilesTrackingService;
